import AppModal from "@/components/AppModal";
import RouteConstant from "@/constant/RouteConstant";
import { Box, Switch, Stack } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Security2FA from "./Security2FA";
import useToggle from "@/hook/useToggle";
import {getTaskId, getUserInfo, setTaskRuleParams} from "@/redux/slices/user";
import { VerifyAction } from "@/constant/VerifyConstant";
import axiosInstance from "@/utils/axios";
import API from "@/constant/API";
import classes from "@/pages/security/css/index.module.less";
import SimpleHeader from "../components/Headers/SimpleHeader";
import { useTheme } from "@mui/material/styles";
import {enqueueSnackbar} from "notistack";
import {dispatch} from "@/redux/store";
import { useConfirm } from "material-ui-confirm";
import { StyledSwitch } from "@/styles/CommonStyledComponents";

function SecurityGA() {
  const { t } = useTranslation();
  const { user } = useSelector(state => state.user);
  const navigate = useNavigate();
  const theme = useTheme();
  const confirm = useConfirm();

  const {
    toggle: show2FA,
    onToggle: onToggleShow2FA,
  } = useToggle(false);

  const _onChange = (evt) => {
    evt.preventDefault();

    if (user.googleBindStatus != 1) {
      _doChange();
      return;
    }

    confirm({
      title: t('warning'),
      description: t('security_option_change_alert_prompt'),
      confirmationText: t('confirm'),
      cancellationText: t('cancel'),
    }).then(() => {
      _doChange();
    });
  }

  const _doChange = () => {
    if (user.googleBindStatus == 1) {
      _onUnbindGA();
    } else {
      _onBindGA();
    }
  }

  const _onUnbindGA = () => {
    setTaskRuleParams({
      action: VerifyAction.CLOSE_GOOGLE,
    })
    onToggleShow2FA();
  }

  const _on2FAAllPass = async () => {
    if (user.googleBindStatus == 1) {
      try {
        await axiosInstance.post(API.GA_UNBIND, {
          taskId: getTaskId(),
        });
        enqueueSnackbar(t('successful'), { variant: 'success' })
        dispatch(getUserInfo());
        onToggleShow2FA();
      } finally {
      }
    } else {
      navigate(RouteConstant.USER_SECURITY_GA_BIND);
    }
  }

  const _onBindGA = () => {
    setTaskRuleParams({
      action: VerifyAction.BIND_GOOGLE,
    })
    onToggleShow2FA();
  }

  if (!user) return null;

  return (<>
    <SimpleHeader />
    <Box className={classes["security-wrap"]}>
      <Box className={classes["security-title-wrap"]}>
        <div className={classes["security-title"]}>{t('google_authenticator')}</div>
        <div className={classes["security-subtitle"]}>{t('google_authenticator_subtitle')}</div>
      </Box>
      <Box className={classes["security-img-wrap"]}>
        <img src={theme.palette.mode === 'dark' ? '/images/account/ga-dark.svg' : '/images/account/ga.svg'} alt=""/>
      </Box>
      <Stack direction="row" alignItems="center" justifyContent="space-between" className={classes["security-switch-module"]}>
        <span className={classes['security-type']}>{t('google_authenticator')}</span>
        <StyledSwitch checked={user.googleBindStatus == 1} onClick={_onChange} />
      </Stack>
      <AppModal open={show2FA} onClose={onToggleShow2FA}>
        <Security2FA callback={_on2FAAllPass} onClose={onToggleShow2FA}/>
      </AppModal> 
    </Box>
  </>);
}

export default SecurityGA;
